module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-hero1.png?47408cee";